import { saveAs } from 'file-saver'
import { Mixpanel } from '../../config/Mixpanel'
import constants from '../PersonaliseLessons/utilities/constants'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import useWindowSize from '../../hooks/useWindowSize'


const CertificateDownload = ({ courseProgress, certificateUrl, handleNavigation }) => {

    const { width } = useWindowSize()

    async function downloadCertificate(link) {
        const bytes = await fetch(link, {
            headers: {
                'Cache-Control': 'no-cache, no-store, must-revalidate'
            }
        })
          .then((res) => res.arrayBuffer())
          .catch((err) => console.log(err));
      
        saveAs(new Blob([bytes]), `Certificate.jpg`);
    }
    
    return (
        <div className='flex rounded-xl items-center' style={{
            background: 'rgba(45, 79, 113, 0.37)'
        }}>
            <div className={`${courseProgress === 100 ? 'w-[125px]' : width <= 360 ? 'w-[130px]' : 'w-[110px]'} h-full`}>
                <img src={courseProgress === 100 ? certificateUrl : 'https://assets.learntube.ai/files/Onboarding_Revamp/image-448%201.png?updatedAt=1696847392130'} alt="" width={99} height={69} className='w-full h-full rounded-tl-xl rounded-bl-xl'/>
            </div>
            <div className='flex-1 py-1.5 md:py-2 ml-2 text-sm font-medium text-white leading-normal relative'>
                <div className='flex justify-between'>
                    <div className='flex items-center'>
                        {courseProgress === 100 ? <div className='w-4 h-4 mr-1 rounded-full bg-[#4CAF50] grid place-content-center'>
                            <FontAwesomeIcon icon={faCheck} color='#fff' className='text-sm'/>
                        </div> : <div className='w-4 h-4 mr-2'>
                            <img src='https://assets.learntube.ai/files/Onboarding_Revamp/Vector.png?updatedAt=1696852250766' alt=''className='w-full h-auto object-cover'/>
                        </div>}
                        <p className='text-sm font-medium pt-1'>{courseProgress !== 100 ? 'Industry Verified Certification' : 'Congratulations!'}</p>
                    </div>
                    {courseProgress === 100 ? <div className='bg-[#17304A] cursor-pointer flex mr-1 items-center py-1.5 px-2 rounded-[19px]' onClick={() => {
                        Mixpanel.track(constants.Mixpanel.NEW_LEADERBOARD_PAGE_CERTIFICATE_WAS_DOWNLOADED)
                        downloadCertificate(certificateUrl)
                    }}>
                        <div className=' w-3 h-3 flex items-center justify-center rounded-full'>
                            <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/download%201.svg?updatedAt=1692792258790" alt="" />
                        </div>
                        <p className='text-[10px] font-medium ml-1'>Download</p>
                    </div> : null}
                </div>
                {courseProgress !== 100 ? <p className='text-xs text-white/50 mr-2 mt-1 md:mt-2 font-medium'> Complete all quizzes to finish the course & unlock your certificate.<img src='https://assets.learntube.ai/files/Lead%20Generation/Frame%2010637.png?updatedAt=1713343429369' width={16} height={16} alt='' className='inline cursor-pointer' onClick={handleNavigation}/></p> : <p className='text-xs opacity-50 mr-2 mt-1 md:mt-2 font-medium'>Your certificate is unlocked! Add it to your CV & linkedin and grow your career.</p>}
            </div>
        </div>
    )
}

export default CertificateDownload
